import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import './navbar.css';

import logo from '../../images/logo.svg';

class Navbar extends React.Component {

  render() {
    return (
      <nav className={"navbar"}>
        <div className="nav-logo">
          <Link to="/">
            <img src={logo} alt={"nanotech lab logo"} />
          </Link>
        </div>
        <div className="nav-links">
        <Link to="/">
          About
        </Link>
        <Link to="/news">
          News
        </Link>
        <Link to="/research">
          Research
        </Link>  
        <Link to="/publications">
          Publications
        </Link>
        <Link to="/team">
          Team
        </Link>
        </div>
      </nav>
    )
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/navbar.js